import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import profileImage from '../../assets/ana_main.JPG.jpeg';
import './About.css';

function About() {
  const { t } = useTranslation();

  return (
    <section className="about-section" id="about">
      <Container>
        <Row className="g-5 align-items-center profile-container-parent">
          <Col md={6} className="text-center">
            <div className="profile-container">
              <div className="profile-image-wrapper">
                <div 
                  className="profile-image"
                  style={{ backgroundImage: `url(${profileImage})` }}
                ></div>
              </div>
              <div className="profile-blur"></div>
            </div>
          </Col>
          
          <Col md={6}>
            <div className="about-content">
              <h4 className="about-subtitle">{t('about.theArtist')}</h4>
              <h3 className="about-title">{t('about.name')}</h3>
              <p className="about-tagline">{t('about.tagline')}</p>
              <p className="about-description">
                {t('about.description')}
              </p>
              
              <Row className="g-4">
                <Col xs={6}>
                  <div className="specialty-card">
                    <span className="material-symbols-outlined specialty-icon">auto_awesome</span>
                    <p className="specialty-text">{t('about.bridesSpecialist')}</p>
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="specialty-card">
                    <span className="material-symbols-outlined specialty-icon">movie</span>
                    <p className="specialty-text">{t('about.redCarpet')}</p>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default About;
